<template>
  <div class="documents-group" :class="{ fake: fake }">
    <div v-if="!fake" class="documents-group__header">
      <div class="documents-group__data">
        <toggle-button v-model="isOpen" class="documents-group__toggler" :disabled="noDocumentsInGroup" />
        <div class="documents-group__info">
          <div class="documents-group__name">
            {{ group.name }}
            <div v-if="hasColorMarks" class="documents-group__colors">
              <document-issue-mark
                v-if="group.absent_color"
                class="documents-group__color"
                issue="absent"
                :color="group.absent_color"
              />
              <document-issue-mark
                v-if="group.expired_color"
                class="documents-group__color"
                issue="expired"
                :color="group.expired_color"
              />
              <document-issue-mark
                v-if="group.expiring_color"
                class="documents-group__color"
                issue="expiring"
                :color="group.expiring_color"
              />
            </div>
          </div>

          <div v-if="group.description" class="documents-group__description">
            {{ group.description }}
          </div>
        </div>
      </div>

      <div class="documents-group__actions">
        <c-button-2 class="documents-group__edit" size="iconic" icon="edit" @click="onEdit" v-if="group.id !== 9999"/>

        <c-button-2
          v-if="group.id !== 9999"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            boundary: 'window',
            content: getToolTipTitle,
            placement: 'top',
          }"
          class="documents-group__edit"
          size="iconic"
          icon="box-arhive"
          @click="onGroupArchive"
        />

        <span v-if="group.docs.length > 0 && group.id !== 9999" :id="`document-group-remove-${group.id}`" class="documents-group__remove" >
          <c-button-2 :icon="{ icon: 'trash', color: 'secondary' }" size="iconic" disabled />
        </span>

        <c-button-2
          v-if="group.docs.length === 0 && group.id !== 9999"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            boundary: 'window',
            content: 'Удалить',
            placement: 'top',
          }"
          :icon="{ icon: 'trash', color: 'secondary' }"
          class="documents-group__remove"
          size="iconic"
          @click="onRemove"
        />

        <b-popover placement="top" triggers="hover blur" :target="`document-group-remove-${group.id}`">
          <error-feedback
            class="m-0 empty-category-tooltip"
            text="В данный момент удаление невозможно, так как тип содержит документы. Сначала перенесите все документы из типа."
          ></error-feedback>
        </b-popover>

        <c-button-2 class="documents-group__move" size="iconic" icon="arrows-constructor" />
      </div>
    </div>

    <slide-up-down :active="isOpen || noDocumentsInGroup" :duration="400" class="documents-group__items">
      <draggable
        class="item-sub item-container"
        group="type"
        :list="group.docs"
        :move="onMove"
        :force-fallback="true"
        ghost-class="sortable__ghost"
      >
        <div v-for="document in group.docs" :key="document.id">
          <document-item
            v-show="isDocumentVisible(document)"
            :document="document"
            :selectedTab="selectedTab"
            @remove="onDocumentRemove(document)"
            @archive="onDocumentArchive(document)"
          ></document-item>
        </div>
      </draggable>
    </slide-up-down>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import SlideUpDown from "vue-slide-up-down";
import ToggleButton from "@/components/controls/toggle-button";
import Button2 from "@/components/controls2/Button";
import ErrorFeedback from "@/components/error-feedback";

import DocumentItem from "./document-item";
import DocumentIssueMark from "./document-issue-mark";

export default {
  name: "documents-group",
  components: {
    draggable,
    "slide-up-down": SlideUpDown,
    "c-button-2": Button2,
    "document-item": DocumentItem,
    "document-issue-mark": DocumentIssueMark,
    "toggle-button": ToggleButton,
    ErrorFeedback,
  },

  props: ["group", "query", "fake", "selectedTab"],

  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    nameMatched() {
      if (this.group.type === "without-group") return false;
      return this.group.name.toLowerCase().includes(this.query);
    },
    hasColorMarks() {
      return this.group.absent_color || this.group.expired_color || this.group.expiring_color;
    },
    noDocumentsInGroup() {
      return this.group.docs.length === 0;
    },
    getToolTipTitle() {
      return this.selectedTab == 0 ? 'Добавить в архив' : 'Восстановить';
    }
  },
  watch: {
    query(v) {
      if (v) this.isOpen = true;
    },
    noDocumentsInGroup(v) {
      if (v) {
        this.isOpen = false;
      }
    },
  },
  created() {
    if (this.query) this.isOpen = true;
    if (this.fake) this.isOpen = true;
  },
 
  methods: {
    onEdit() {
      this.$emit("edit-group", { group: this.group });
    },
    onRemove() {
      this.$emit("remove-group", { group: this.group });
    },
    onDocumentRemove(document) {
      this.$emit("remove-document", { group: this.group, document });
    },
    onGroupArchive() {
      this.$emit("archiveGroup", {group: this.group});
    },
    onDocumentArchive(document) {
      this.$emit("archiveDocument", {document, group: this.group});
    },
    onSort(event) {
      this.$emit("input");
      if (event.added) {
        this.$emit("add-document", {
          group: this.group,
          document: event.added.element,
        });
      }
      this.$emit("resort", event);
    },
    isDocumentVisible(doc) {
      if (!this.query) return true;
      if (this.nameMatched) return true;
      return doc.name.toLowerCase().includes(this.query);
    },
    onMove(event) { 
      event.relatedContext.component.$emit("moving");
    },
    onMovingElement() { 
      this.isOpen = true;
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/vars";

.documents-group {
  &__header {
    display: flex;
    align-items: center;
    min-height: 48px;
    padding: 12px 16px;
    padding-right: 10px;
    border: 1px solid $color-border-light;
    cursor: pointer;

    @include onlyExtraSmall {
      border-right: none;
      border-left: none;
    }
  }

  &__data {
    flex-grow: 1;
    overflow: hidden;
    display: flex;
    align-items: center;
  }

  &__toggler {
    margin-right: 14px;
  }

  &__name {
    min-width: fit-content;
    margin-bottom: 3px;
    display: flex;
    margin-right: 16px;
    @include onlyExtraSmall {
      flex-direction: column;
    }
  }
  &__info {
    @media (min-width: 640px) {
      display: flex;
      align-items: center;
    }
    flex-wrap: wrap;
    font-weight: 500;
    font-size: 15px;
    line-height: 108%;
    color: #000000;
    max-width: calc(100% - 40px);
    margin-right: 16px;
    overflow-wrap: break-word;
  }
  &__description {
    margin-top: 2px;
    font-weight: 400;
    padding-right: 10px;
    @media (min-width: 640px) {
      margin-top: 0;
    }
  }
  &__colors {
    display: flex;
    margin-left: 16px;
    @include onlyExtraSmall {
      margin-left: 0;
    }
  }

  .documents-group__color ~ .documents-group__color {
    margin-left: 6px;
  }

  &__description {
    color: $color-label;
    font-size: 11px;
  }

  &__actions {
    flex-shrink: 0;
    display: flex;
    align-items: flex-end;
    font-size: 11px;
  }

  &__edit {
    margin-right: 16px;
  }

  &__remove {
    margin-right: 15px;
    transform: translateY(-2px);
  }

  &__move {
    //transform: translateY(-1px);
  }

  &__items {
    padding-left: 16px;

    .document-item:first-child {
      margin-top: -1px;
    }
  }

  &.fake {
    margin-top: 14px;
    .documents-group__items {
      padding-left: 0;
    }
  }
}
.empty-category-tooltip {
  max-width: 200px;
}
</style>
